// extracted by mini-css-extract-plugin
export default {"backdrop":"ImageModal_backdrop__dA50Q","modal_info":"ImageModal_modal_info__j00Jh","modal_info_image":"ImageModal_modal_info_image__4vhZn"};